module.exports = __webpack_public_path__ + "static/why-us-1-618003af08bc6cc60374cfc22b60f0ea.jpg";